import { render, staticRenderFns } from "./FeaturedText.vue?vue&type=template&id=74b1004b&scoped=true&"
import script from "./FeaturedText.vue?vue&type=script&lang=js&"
export * from "./FeaturedText.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedText.vue?vue&type=style&index=0&id=74b1004b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b1004b",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/FeaturedText.vue
// module id = 130
// module chunks = 0